export const INVOICE_ITEMS = {
  membership_fee: 'Signup/Membership Fee',
  market_charges: 'Market Charges',
  tax: 'Tax',
  addons: 'Addons',
};
